import { UserState } from "store/user/types";

export function useIsResellerAdmin(user: UserState): boolean {
    return user.userInfo.Claims?.Details?.Roles.includes("ResellerAdmin");
}
